(function () {
    'use strict';

    angular.module("imApp").factory("srFollowUpService", ['$ihttp', function ($ihttp) {
        var service = {
            getSrFollowUp: function (parms) {
                return $ihttp.post({
                    method: 2130,
                    parameters: parms || {}
                });
            },
            listResponsibleLabours: function (parms) {
                return $ihttp.post({
                    method: 2131,
                    parameters: parms || {}
                });
            },
            listExperienceComments: function (parms) {
                return $ihttp.post({
                    method: 2132,
                    parameters: parms || {}
                });
            },
            addNewResponsibleLabour: function (parms) {
                return $ihttp.post({
                    method: 2134,
                    parameters: parms
                });
            },
            addExperienceComment: function (parms) {
                return $ihttp.post({
                    method: 2133,
                    parameters: parms
                });
            }
        };

        return service;
    }]);
})();